module.exports = __webpack_public_path__ + "img/weather12.55a1b4fa.png";